/*
 * @Descripttion:
 * @version:
 * @Author: wangluyao
 * @Date: 2023-07-04 13:06:32
 * @LastEditors: wangluyao
 * @LastEditTime: 2023-07-19 10:29:42
 */
import type { AppRouteModule } from '/@/router/types';

import { LAYOUT } from '/@/router/constant';
import { t } from '/@/hooks/web/useI18n';

/**
 * 'sample': '样品管理',
 */
const route: AppRouteModule = {
  path: '/sample',
  name: 'Sample',
  component: LAYOUT,
  redirect: '/certification/license',
  meta: {
    icon: 'mdi:test-tube-empty',
    title: t('routes.sample.main'),
    orderNo: 1100,
    roles: [20222058],
  },
  children: [
    /**
     * essence: '供应商香精小样反馈',
     */
    {
      path: 'essence',
      name: 'SampleEssence',
      component: () => import('/@/views/sample/essence/index.vue'),
      meta: {
        title: t('routes.sample.essence'),
        roles: [20222059],
      },
    },
    /**
     * sample-submission-inspection: '样品送检',
     */
    {
      path: 'sample-submission-inspection',
      name: 'SampleSubmissionInspection',
      component: () => import('/@/views/sample/sample-submission-inspection/index.vue'),
      meta: {
        title: t('routes.sample.sample-submission-inspection'),
        roles: [20222060],
      },
    },
    /**
     * sample-submission-address: '样品送检地址',
     */
    {
      path: 'sample-submission-address',
      name: 'SampleSubmissionAddress',
      component: () => import('/@/views/sample/sample-submission-address/index.vue'),
      meta: {
        title: t('routes.sample.sample-submission-address'),
        // roles: [20222059],
      },
    },
  ],
};

export default route;
